import { render, staticRenderFns } from "./PolizasSGImportView.vue?vue&type=template&id=0f117b1e&"
import script from "./PolizasSGImportView.vue?vue&type=script&lang=js&"
export * from "./PolizasSGImportView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports